import { Directive, HostListener, Inject } from "@angular/core";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { DOCUMENT } from "@angular/common";

@Directive({
  selector: "[klSidebarToggle]",
})
export class SidebarToggleDirective {
  constructor() {}

  @HostListener("click", ["$event"])
  toggleOpen($event: any) {
    $event.preventDefault();
    document.querySelector("body").classList.toggle("sidebar-hidden");
  }
}

@Directive({
  selector: "[klFullscreen]",
})
export class FullscreenDirective {
  constructor(@Inject(DOCUMENT) private document: any) {}

  elem: any;

  @HostListener("click", ["$event"])
  toggleOpen($event: any) {
    $event.preventDefault();
    if (this.hasClass(document.querySelector("body"), "fullscreen")) {
      this.closeFullscreen();
      document.querySelector("body").classList.toggle("fullscreen");
    } else {
      this.openFullscreen();
      document.querySelector("body").classList.toggle("fullscreen");
    }
  }

  private hasClass(target: any, elementClassName: string) {
    return new RegExp("(\\s|^)" + elementClassName + "(\\s|$)").test(
      target.className
    );
  }

  // Toggle element class
  private toggleClass(elem: any, elementClassName: string) {
    let newClass = " " + elem.className.replace(/[\t\r\n]/g, " ") + " ";
    if (this.hasClass(elem, elementClassName)) {
      while (newClass.indexOf(" " + elementClassName + " ") >= 0) {
        newClass = newClass.replace(" " + elementClassName + " ", " ");
      }
      elem.className = newClass.replace(/^\s+|\s+$/g, "");
    } else {
      elem.className += " " + elementClassName;
    }
  }

  openFullscreen() {
    this.elem = document.documentElement;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      this.elem.msRequestFullscreen();
    }
  }

  closeFullscreen() {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      this.document.msExitFullscreen();
    }
  }
}

@Directive({
  selector: "[klSidebarMinimizer]",
})
export class SidebarMinimizeDirective {
  constructor(private explorerService: ExplorerService) {}

  @HostListener("click", ["$event"])
  toggleOpen($event: any) {
    $event.preventDefault();
    document.querySelector("body").classList.toggle("aside-collapsed");
    this.explorerService.menuCollapse();
  }
}

@Directive({
  selector: "[klMobileSidebarToggler]",
})
export class MobileSidebarToggleDirective {
  constructor() {}

  // Check if element has class
  private hasClass(target: any, elementClassName: string) {
    return new RegExp("(\\s|^)" + elementClassName + "(\\s|$)").test(
      target.className
    );
  }

  @HostListener("click", ["$event"])
  toggleOpen($event: any) {
    $event.preventDefault();
    document.querySelector("body").classList.toggle("sidebar-mobile-show");
  }
}

/**
 * Allows the off-canvas sidebar to be closed via click.
 */
@Directive({
  selector: "[klSidebarClose]",
})
export class SidebarOffCanvasCloseDirective {
  constructor() {}

  // Check if element has class
  private hasClass(target: any, elementClassName: string) {
    return new RegExp("(\\s|^)" + elementClassName + "(\\s|$)").test(
      target.className
    );
  }

  // Toggle element class
  private toggleClass(elem: any, elementClassName: string) {
    let newClass = " " + elem.className.replace(/[\t\r\n]/g, " ") + " ";
    if (this.hasClass(elem, elementClassName)) {
      while (newClass.indexOf(" " + elementClassName + " ") >= 0) {
        newClass = newClass.replace(" " + elementClassName + " ", " ");
      }
      elem.className = newClass.replace(/^\s+|\s+$/g, "");
    } else {
      elem.className += " " + elementClassName;
    }
  }

  @HostListener("click", ["$event"])
  toggleOpen($event: any) {
    $event.preventDefault();
    if (this.hasClass(document.querySelector("body"), "sidebar-off-canvas")) {
      this.toggleClass(document.querySelector("body"), "sidebar-opened");
    }
  }
}
